<template>
    <div>
        <div class="breadcrumb m-0 text-22">
            <slot name="header">
                <ul>
                    <li
                        v-for="(page, index) in pages"
                        :key="`breadcrumb-${index}`"
                    >
                        <router-link
                            v-if="index < (pages.length - 1)"
                            class="typo_link text-primary"
                            :to="page.to"
                        >
                            <span>{{ page.name }}</span>
                        </router-link>
                        <span v-else class=" text-dark">{{ page.name }}</span>
                    </li>
                </ul>
            </slot>
        </div>
    </div>
</template>
<script>
export default {
    props: ['pages'],
}
</script>
<style scoped>
    .breadcrumb {
        background: transparent;
        align-items: center;
        margin: 0 0 1.25rem;
        padding: 0;
    }
    .breadcrumb ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .breadcrumb ul li {
        display: inline-block;
        position: relative;
        padding: 0 0.5rem;
        vertical-align: bottom;
        color: #332e38;
    }
    .breadcrumb ul li:after {
        position: absolute;
        top: 6px;
        right: 0;
        content: "";
        height: 24px;
        width: 1px;
        background: #332e38;
        border-radius: 5px;
    }
    .breadcrumb ul li:last-child:after {
        display: none;
    }
    .breadcrumb ul li a {
        color: #03060a;
    }
</style>
